<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card>
          <v-toolbar
            color="primary"
            flat
            short
          >
            <v-toolbar-title><v-icon>mdi-lock</v-icon></v-toolbar-title>
          </v-toolbar>

          <v-card-text class="px-5 pt-5">
            <v-form
              ref="loginForm"
              autocomplete="off"
            >
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Email"
                type="text"
                autofocus
                autocomplete="off"
              ></v-text-field>

              <v-text-field
                v-model="password"
                :rules="passwordRules"
                label="Wachtwoord"
                type="password"
                autocomplete="off"
              ></v-text-field>

              <v-input
                v-if="error"
                error-messages="Inloggegevens zijn ongeldig"
              ></v-input>

            </v-form>
          </v-card-text>
          <v-card-actions class="px-5 pb-5">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="doLogin">Inloggen</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Login',
  components: {
  },
  data: () => ({
    email: '',
    password: '',

    error: false,

    emailRules: [email => !!email || "Email is verplicht"],
    passwordRules: [password => !!password || "Wachtwoord is verplicht"],

  }),
  created() {
    this.$store.dispatch('session/fullHeight', true)
    this.$store.dispatch('session/title', null)
  },
  destroyed() {
    this.$store.dispatch('session/fullHeight', false)
  },
  methods: {
    doLogin() {
      this.error = false
      if (this.$refs.loginForm.validate()) {
        this.$store.dispatch('auth/login', {
          username: this.email,
          password: this.password,
        }).then(() => {
          this.$router.push(this.$router.currentRoute.query.redirect || { name: 'home' })
        }).catch(() => {
          this.error = true
        })
      }
    },
  },

}
</script>
